import React, { useEffect } from 'react';

/**
 * TrackedField - Input/Textarea variant that records the last focused element on window,
 * so the SymbolToolbar can insert content into it.
 */
export const TrackedInput = React.forwardRef((props, ref) => (
  <input ref={ref} {...props} onFocus={(e) => { window.__mgLastFocused = e.target; props.onFocus && props.onFocus(e); }} />
));
TrackedInput.displayName = 'TrackedInput';

export const TrackedTextarea = React.forwardRef((props, ref) => (
  <textarea ref={ref} {...props} onFocus={(e) => { window.__mgLastFocused = e.target; props.onFocus && props.onFocus(e); }} />
));
TrackedTextarea.displayName = 'TrackedTextarea';

// Hook: attaches global focus tracker across the app for any input/textarea inside a container
export const useFocusTracker = () => {
  useEffect(() => {
    const handler = (e) => {
      const tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') {
        window.__mgLastFocused = e.target;
      }
    };
    document.addEventListener('focusin', handler);
    return () => document.removeEventListener('focusin', handler);
  }, []);
};
